import React, { useEffect, useState } from "react";
import $ from "jquery";

export default function Header({ handleIsEnquiry, isEnquiry }) {
  useEffect(() => {
    function headerStyle() {
      if ($(".main-header").length) {
        var windowpos = $(window).scrollTop();
        var siteHeader = $(".main-header");
        var scrollLink = $(".scroll-top");
        if (windowpos >= 80) {
          siteHeader.addClass("fixed-header");
          scrollLink.addClass("open");
        } else {
          siteHeader.removeClass("fixed-header");
          scrollLink.removeClass("open");
        }
      }
    }

    $(window).on("scroll", function () {
      headerStyle();
    });
  });
  let [currentActive, setCurrentActive] = useState("home");
  const sections = [
    { id: "banner-section1", name: "home" },
    { id: "services", name: "services" },
    { id: "gallery", name: "gallery" },
    { id: "login", name: "login" },
    { id: "enquiry", name: "enquiry" },
  ];
  //function to show current active link on header
  const handleScroll = () => {
    let activeSection = ""; // Default section
    sections.forEach((section) => {
      const element = document.getElementById(section.id);
      if (element) {
        const rect = element.getBoundingClientRect();
        // Check if the section is in the viewport
        if (
          rect.top <= window.innerHeight / 2 &&
          rect.bottom >= window.innerHeight / 2
        ) {
          activeSection = section.name;
        }
      }
    });

    setCurrentActive(activeSection);

    // Remove 'current' class and reset styles for all menu items
    $(".main-menu li").removeClass("current");
    $(".main-menu li a").css("color", "#fff"); // Reset color of all items
    $(".main-menu li a *").css("color", "#fff"); // Reset color of all children

    // Add 'current' class to active menu item and update its styles
    let currentItem;
    if (activeSection === "login" || activeSection == "enquiry") {
      const contactClassName = isEnquiry==='enquiry' ? "enquiry" : "login";
      currentItem = $(`.main-menu li .${contactClassName}`).parent();
    } else {
      currentItem = $(`.main-menu li a[href="#${activeSection}"]`).parent();
    }
    currentItem.addClass("current");
    currentItem.find("a").css("color", "#ff9a68"); // Set color of the active item
    currentItem.find("a *").css("color", "#ff9a68"); // Set color of the active item's children
  };                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                          
  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    // console.log(currentActive);
    return () => {
      window.removeEventListener("scroll", handleScroll); // Clean up on unmount
    };
  }, [currentActive]);
  //controlling active link for login enquiry - shahin
  const handleLoginSignupActive = () => {
    if (currentActive != "login" && currentActive != "enquiry") {
      return;
    }
    $(".main-menu li").removeClass("current");
    $(".main-menu li a").css("color", "#fff"); // Reset color of all items
    $(".main-menu li a *").css("color", "#fff");
    let currentItem;
    const contactClassName = isEnquiry==='enquiry' ? "enquiry" : "login";
    currentItem = $(`.main-menu li .${contactClassName}`).parent();
    currentItem.addClass("current");
    currentItem.find("a").css("color", "#ff9a68"); // Set color of the active item
    currentItem.find("a *").css("color", "#ff9a68");
  };
  //login enquiry activity on state change - shahin
  useEffect(() => {
    handleLoginSignupActive();
    return () => {
      handleLoginSignupActive(); // Clean up on unmount
    };
  }, [isEnquiry]);

  const renderMenus = () => {
    return (
      <div
        className="collapse navbar-collapse show clearfix"
        id="navbarSupportedContent"
      >
        <ul className="navigation clearfix">
          <li
            className={`dropdown ${currentActive == "home" ? "current" : ""
              }`}
            onClick={() => {
              console.log("home clicked");
            }}
          >
            <a href="#banner-section1">Home</a>
          </li>
          <li
            className={`dropdown ${currentActive == "services" ? "current" : ""
              }`}
          >
            <a href="#services">Services</a>
          </li>
          {/* <li
            className={`dropdown ${currentActive == "gallery" ? "current" : ""
              }`}
          >
            <a href="#gallery">Gallery</a>
          </li> */}
          <li
            className={`dropdown ${currentActive == "enquiry" ? "current" : ""
              }`}
          >
            <a
              href="#enquiry"
              className="enquiry"
              onClick={() => {
                handleIsEnquiry('enquiry');
              }}
            >
              Enquiry
            </a>
          </li>
          <li
            className={`dropdown ${currentActive == "login" ? "current" : ""
              }`}
          >
            <a
              href="#login"
              className="login"
              onClick={() => {
                handleIsEnquiry('login');
              }}
            >
              Login
            </a>
          </li>
          {/* <li
            className={`dropdown ${currentActive == "login" ? "current" : ""
              }`}
          >
            <a
              href="#enquiry"
              className="enquiry"
              onClick={() => {
                handleIsEnquiry(true);
              }}
            >
              Register Now
            </a>
          </li> */}
        </ul>
      </div>
    )
  }


  return (
    <header
      className="main-header style-three"
      style={{ background: "linear-gradient(to left, #1F67E2, #CBDEFB 90%)" }}
    >
      <div className="auto-container">
        <div className="header-upper">
          <div className="outer-box clearfix">
            <div className="logo-box pull-left">
              <figure className="logo">
                <a href="#">
                  <img
                    style={{ width: "221px" }}
                    src="assets/images/logo-light.svg"
                    alt=""
                  />
                </a>
              </figure>
            </div>
            <div className="nav-box pull-right clearfix">
              <div className="menu-area pull-left">
                {/*Mobile Navigation Toggler*/}
                <div className="mobile-nav-toggler">
                  <i className="icon-bar" />
                  <i className="icon-bar" />
                  <i className="icon-bar" />
                </div>
                <nav className="main-menu clearfix">
                  {renderMenus()}
                </nav>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/*sticky Header*/}
      <div className="sticky-header">
        <div className="container clearfix">
          <figure className="logo-box">
            <a href="#">
              <img
                style={{ width: "201px" }}
                src="assets/images/logo-light.svg"
                alt=""
              />
            </a>
          </figure>
          <div className="menu-area">
            <nav className="main-menu clearfix">
              {renderMenus()}
            </nav>
          </div>
        </div>
      </div>
    </header>
  );
}
